<script lang="ts">
    import {getContext} from 'svelte';
    import {EDITORS_LOCALIZE} from '../../context-keys';
    import type {EditorsLocalizationFunction} from '../../localizations/types';
    import type {ObjectValueEditorLocalizations} from '../meta-editors/object/types';
    import type {ListValueEditorLocalizations} from '../meta-editors/list/types';
    import {getValueEditorLabelContext} from './value-editor-label-context';

    export let fieldRequired: boolean;
    export let additionalClasses = '';

    const localize: EditorsLocalizationFunction<ObjectValueEditorLocalizations | ListValueEditorLocalizations> = getContext(EDITORS_LOCALIZE);
    const valueEditorLabelContext = getValueEditorLabelContext();

    const labelClickEvent$ = valueEditorLabelContext.clickEvent$;
    const labelConfig = valueEditorLabelContext.config;

    $: markAsRequired = fieldRequired && !$labelConfig.disableRequiredAsterisk;
    $: forAttribute = $labelConfig.disableForAttribute ? null : valueEditorLabelContext.editorId;

    function onLabelClick() {
        labelClickEvent$.next();
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions label is clickable to emulate input focus on label click for non-native inputs -->
<label id={valueEditorLabelContext.labelId}
       for={forAttribute}
       class={additionalClasses}
       class:required={markAsRequired}
       on:click={onLabelClick}>
    <slot/>
    <span class="required-asterisk" class:hidden={!markAsRequired} aria-hidden="true">*</span>
    <span class:hidden={!markAsRequired} class="sr-only">({localize('required')})</span>
</label>

<style lang="less">
    label > .required-asterisk {
        color: red;
        vertical-align: super;
        font-size: 10px;
        margin-left: 2px;
    }
</style>